export default {
  ppn: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
};
